import React from 'react';

export default function Footer(props) {
    return (
        <div className="dealer-footer">
            { props.children }
        </div>
    )
}